import React from "react";
import { Button } from "@/components/ui/button";
import { Edit2, Layers, Ban, X, CheckSquare } from "lucide-react";

export const BulkActionBar = ({
  selectedTxns,
  setSelectedTxns,
  setSelectAll,
  onBulkUpdateParty,
  onBulkAssignSection,
  onBulkExclude,
}) => {
  if (selectedTxns.size === 0) return null;
  return (
    <div
      className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between"
      data-testid="bulk-action-bar"
    >
      <div className="flex items-center gap-2">
        <CheckSquare className="w-5 h-5 text-blue-600" />
        <span className="font-medium text-blue-900">
          {selectedTxns.size} transaction{selectedTxns.size > 1 ? "s" : ""} selected
        </span>
      </div>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={onBulkUpdateParty} data-testid="bulk-update-party-btn">
          <Edit2 className="w-4 h-4 mr-2" />
          Update Name/PAN
        </Button>
        <Button size="sm" variant="outline" onClick={onBulkAssignSection} data-testid="bulk-assign-section-btn">
          <Layers className="w-4 h-4 mr-2" />
          Assign Section
        </Button>
        <Button
          size="sm"
          variant="outline"
          className="text-red-600 border-red-200 hover:bg-red-50"
          onClick={onBulkExclude}
          data-testid="bulk-exclude-btn"
        >
          <Ban className="w-4 h-4 mr-2" />
          Exclude All
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => {
            setSelectedTxns(new Set());
            setSelectAll(false);
          }}
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
